//GLOBAL ENGLISH

const englishTranslations = {
  navbar: {
    navItems: {
      home: "Home",
      services: "Services",
      contact: "Contact",
      testimonials: "Testimonials",
    },
    ctaButton: "Get A Quote",
  },
  heroHeading: "Interior Design",
  heroText:
    "Step into a world where the art of Interior Design is meticulously crafted to bring together timeless elegance and cutting-edge modern Innovation, Allowing you to transform your living spaces into the epitome of luxury and sophistication",
  heroCta: "Start Project",
  countHeading1: "Project Complete",
  count1: "400",
  countHeading2: "Satisfied Clients",
  count2: "600",
  countHeading3: "Unique Styles",
  count3: "100",

  // services
  serviceHeading: "Our Services",
  services: {
    title1: "Lighting Design",
    description1:
      "Achieve the perfect balance of ambient, task, and accent lighting for a functional atmosphere",
    title2: "Interior Design",
    description2:
      "From concept to completion, we oversee every detail to bring your vision to life efficiently",
    title3: "Outdoor Design",
    description3:
      "Celebrate the changing seasons with our seasonal outdoor decor services",
  },

  designHeading: "Designing Your Dream With Brilliance",
  designText:
    "Elevate your spaces with bespoke interior designs that reflect your unique style and aspirations, crafted with precision and brilliance for an unforgettable living experience",

  accordian: {
    title1: "Living Room Interior Design",
    description1:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio placeat repellendus veniam, corporis expedita doloribus facilis eos quis doloremque enim in quas quibusdam incidunt facere.",
    title2: "Commercial Office Room Interior Design",
    description2:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio placeat repellendus veniam, corporis expedita doloribus facilis eos quis doloremque enim in quas quibusdam incidunt facere.",
  },

  stepsHeading: "Designing Your Dream in Three Simple Steps",
  steps: {
    title1: "Start Project",
    description1:
      "Embark on your design adventure by initiating your project. Share your vision and set the stage for a bespoke design experience",
    title2: "Craft",
    description2:
      "Collaborate closely to achieve design excellence refining your vision and crafting brilliance into every aspect of your space",
    title3: "Execute",
    description3:
      "Witness your vision becoming a reality as we execute the design plan with precision. Celebrate the joy of your newly transformed space",
  },

  testimonialsHeading: "What Our Customers Say About Us",
  testimonialsHeadingSmall: "Testimonies",
  testimonials: {
    review1:
      "Working with your design team was an absolute pleasure. The attention to detail and creativity exceeded my expectations. Thank you for making my home beautiful!",
    author1: "Sophie Carter",
    location1: "New York, USA",
    review2:
      "Exceptional service! From the initial consultation to the final reveal, your team demonstrated professionalism and a keen eye for design. Highly recommend!",
    author2: "James Bennett",
    location2: "Toronto, Canada",
  },

  formHeading: "Get In Touch",
  formText:
    "Elevate your spaces with bespoke interior designs that reflect your unique style and aspirations",
  subjectPlaceholder: "Subject",
  send: "Send",
  messagePlaceholder: "Message",
  footerText:
    "VivaDecor Your premier destination for luxury and modern interior design",
  footerHeading1: "Our Services",
  heading1Text1: "Indoor Design",
  heading1Text2: "Outdoor Design",
  heading1Text3: "Lightning Design",
  heading1Text4: "Office Design",
  footerHeading2: "Contact Us",
  heading2Text1: "info@vivadecor.com",
  heading2Text2: "Design Avenue Cityvilla, CA 90210 United States",
};

export default englishTranslations;
